import { render } from "./PublicProcedures.vue?vue&type=template&id=907ee7c6&scoped=true"
import script from "./PublicProcedures.vue?vue&type=script&lang=js"
export * from "./PublicProcedures.vue?vue&type=script&lang=js"

import "./PublicProcedures.vue?vue&type=style&index=0&id=907ee7c6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907ee7c6"]])

export default __exports__